import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import {
  Button,
  Col,
  Form,
  ListGroup,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import * as Yup from "yup";
import { Field, FormikProvider, useFormik } from "formik";
import { Link } from "react-router-dom";
// import swal from "sweetalert";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  capitalizeString,
  delete_Record,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { Spin } from "antd";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  GET_MaterialCategoryTypes,
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetMachineParameters,
  POST_GetMachinesDropDownList,
  POST_GetMaterialCategoryByID,
  POST_GetMaterialCategoryListByCategoryType,
  POST_MaterialCategoryDelete,
  POST_MaterialCategoryExport,
  POST_MaterialCategoryInsert,
  POST_MaterialCategoryStatusUpdate,
  POST_MaterialCategoryUpdate,
} from "../../../helpers/url_helper";
import { get, post } from "../../../helpers/api_helper";
import { useFilter } from "../../../../context/FilterContext";
import QuickAddCategory from "../Categories/QuickAddCategory";

const MaterialCategories = () => {
  const [showFilter, setShowFilter] = useState(false);
  const { filter, updateFilter } = useFilter();

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "material-categories" ? filter?.CurrentPage : 1,
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "material-categories" ? filter?.PageSize : 10,
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "material-categories" ? filter?.sortBy : "",
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "material-categories" ? filter?.orderBy : "asc",
  );

  const [isReset, setIsReset] = useState(false);

  const [categoryTypeList, setCategoryTypeList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);

  const [categoryType, setCategoryType] = useState(1);
  const [categoryTypeName, setCategoryTypeName] = useState("Material Type");

  const [categoryModal, setCategoryModal] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Status:
        filter && filter?.page == "material-categories" ? filter?.Status : -1,
      Search:
        filter && filter?.page == "material-categories" ? filter?.Search : "",
      // Search: "",
      // Status: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: { Search, Status },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      Status: -1,
      Search: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const get_MaterialCategoryTypes = async () => {
    setIsLoading(true);
    await get(GET_MaterialCategoryTypes)
      .then((response) => {
        if (response?.IsSuccess) {
          if (
            AuthUser?.Permissions?.DT == 1 ||
            AuthUser?.Permissions?.FoodTesting == 1
          ) {
            setCategoryTypeList(response?.List);
          } else {
            setCategoryTypeList(
              response?.List?.filter((x) => x.CategoryType != 2),
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    get_MaterialCategoryTypes();
    getUnitDDL();
  }, []);

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    formikFilter.resetForm();
    if (sortBy != "") {
      setSortBy("");
    } else {
      getData();
    }
  }, [categoryType]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "material-categories",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Status: Status,
      Search: Search ? Search : "",
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      CategoryType: categoryType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };

    await post(POST_GetMaterialCategoryListByCategoryType, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setCategoryList(response?.List);
        setIsLoading(false);

        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Search: Search,
      Status: Status,
      CategoryType: categoryType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    post(POST_MaterialCategoryExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    CategoryName: Yup.string()
      .trim()
      .required(`${categoryTypeName} is required field`),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      MaterialCategoryIDEncrypted: "",
      CategoryType: categoryType,
      CategoryName: "",
      Description: "",
      ShortCode: "",
      ParameterMachineMappingList: [],
      ParameterMachineLinkList: [],
      searchMachineParameters: "",
      searchParameterMachines: "",
      UnitID: "",
      DisposalDays: "",
      ReadingCount: "1",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ParameterMachineMappingList,
      ParameterMachineLinkList,
      searchMachineParameters,
      searchParameterMachines,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      categoryType == 2 &&
      (values?.ShortCode?.trim()?.toLowerCase() == "pi" ||
        values?.ShortCode?.trim()?.toLowerCase() == "e" ||
        values?.ShortCode?.trim()?.toLowerCase() == "null")
    ) {
      formik.setFieldError(
        "ShortCode",
        "'Pi', 'E' & 'NULL' can not be used as short code",
      );
      formik.setFieldTouched("ShortCode", true);
      return;
    }

    setIsLoading(true);
    let payload = {
      MaterialCategoryIDEncrypted: values.MaterialCategoryIDEncrypted
        ? values.MaterialCategoryIDEncrypted
        : "",
      CategoryType: categoryType,
      CategoryName: values.CategoryName.trim(),
      Description: values.Description.trim(),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser.BranchIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ShortCode: categoryType == 2 ? values.ShortCode.trim() : "",
      ReadingCount:
        categoryType == 2
          ? values?.ReadingCount == 0
            ? 1
            : values?.ReadingCount
          : 0,
      // CSV parameters count only while their machine is ticked in Machines Mapping
      ParameterMachineMappingList: values?.ParameterMachineMappingList?.filter(
        (x) =>
          x.IsSelected == true &&
          values?.ParameterMachineLinkList?.some(
            (m) => m.IsSelected && m.MachineIDEncrypt == x.MachineIDEncrypt,
          ),
      ),
      ParameterMachineLinkList: values?.ParameterMachineLinkList?.filter(
        (x) => x.IsSelected == true,
      ).map((x) => ({ MachineIDEncrypt: x.MachineIDEncrypt })),
      UnitID: categoryType == 2 ? (values?.UnitID ? values?.UnitID : 0) : 0,
      DisposalDays: values?.DisposalDays ? values?.DisposalDays : 0,
    };
    post(
      values.MaterialCategoryIDEncrypted
        ? POST_MaterialCategoryUpdate
        : POST_MaterialCategoryInsert,
      payload,
    )
      .then((response) => {
        if (response.IsSuccess) {
          //swal("Success!", response.Message, "success");
          successMessage(response?.Message);
          formik.resetForm();
          // the dialog stays open after an insert (quick successive adds), so reload the lists that resetForm just emptied
          if (categoryType == 2 && !values.MaterialCategoryIDEncrypted) {
            getMachineParameterList();
            getParameterMachineLinkList();
          }
          getData(1, currentSizePerPage);
          if (values.MaterialCategoryIDEncrypted) {
            setCategoryModal(false);
          }
        } else {
          // swal("Error!", response.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  function add_category() {
    formik.resetForm();
    formik.setFieldValue("CategoryType", categoryType);
    if (categoryType == 2) {
      getMachineParameterList();
      getParameterMachineLinkList();
    }
    setCategoryModal(true);
  }

  const get_MaterialCategoryByID = async (ID) => {
    setIsLoading(true);
    await post(POST_GetMaterialCategoryByID, {
      MaterialCategoryIDEncrypted: ID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.resetForm();
          formik.setValues({
            MaterialCategoryIDEncrypted: ID,
            CategoryType: categoryType,
            CategoryName: response.CategoryName,
            Description: response.Description,
            ShortCode: response.ShortCode,
            ReadingCount: response.ReadingCount,
            ParameterMachineMappingList: response?.MachineMappingList?.map(
              (item) => ({
                ...item,
                display: true,
              }),
            ),
            // a machine that already has saved CSV parameters counts as ticked (saved before Machines Mapping existed)
            ParameterMachineLinkList: response?.MachineLinkList?.map((item) => ({
              ...item,
              IsSelected:
                item.IsSelected ||
                (response?.MachineMappingList || []).some(
                  (m) =>
                    m.IsSelected && m.MachineIDEncrypt == item.MachineIDEncrypt,
                ),
              display: true,
            })),
            searchMachineParameters: "",
            searchParameterMachines: "",
            UnitID: response.UnitID,
            DisposalDays: response.DisposalDays,
          });
          setCategoryModal(true);
        } else {
          //swal("Error!", response.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getMachineParameterList = async () => {
    setIsLoading(true);
    await post(POST_GetMachineParameters, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response.IsSuccess) {
          formik.setFieldValue(
            "ParameterMachineMappingList",
            response.MachineParameterList.map((item) => ({
              ...item,
              IsSelected: false,
              display: true,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // Machines Mapping list for a NEW non-standard parameter (nothing ticked); edit mode gets it from MaterialCategory_GetByID
  const getParameterMachineLinkList = async () => {
    setIsLoading(true);
    await post(POST_GetMachinesDropDownList, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ParameterMachineLinkList",
            (response?.MachinesDropDownList || []).map((item) => ({
              MachineIDEncrypt: item.MachineIDEncrypt,
              MachineName: item.MachineName,
              IsSelected: false,
              display: true,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // a CSV parameter row is shown only while its machine is ticked in Machines Mapping
  const isMachineTicked = (machineIDEncrypt) =>
    ParameterMachineLinkList?.some(
      (m) => m.IsSelected && m.MachineIDEncrypt == machineIDEncrypt,
    );
  const isCsvRowVisible = (x) =>
    x.display == true && isMachineTicked(x.MachineIDEncrypt);

  const handleChangeSearchParameterMachines = (e) => {
    const search = e?.target?.value?.toLowerCase() ?? "";
    formik.setFieldValue("searchParameterMachines", e?.target?.value);
    formik.setFieldValue(
      "ParameterMachineLinkList",
      ParameterMachineLinkList?.map((x) => ({
        ...x,
        display: x.MachineName?.toLowerCase().includes(search) ? true : false,
      })),
    );
  };

  const handleChangeSearchMachineParameters = (e) => {
    formik.setFieldValue("searchMachineParameters", e?.target?.value);
    formik.setFieldValue(
      "ParameterMachineMappingList",
      ParameterMachineMappingList?.map((x) => {
        return {
          ...x,
          display:
            x.MachineName?.toLowerCase().includes(
              e?.target?.value?.toLowerCase(),
            ) ||
            x.MachineParameter?.toLowerCase().includes(
              e?.target?.value?.toLowerCase(),
            )
              ? true
              : false,
        };
      }),
    );
  };

  const [unitOptions, setUnitOptions] = useState([]);

  const getUnitDDL = () => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 8, // Unit
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setUnitOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showQuickAddCategoryModal, setShowQuickAddCategoryModal] =
    useState(false);
  const [categoryTypeQuickAdd, setCategoryTypeQuickAdd] = useState(0);
  const [parentCategoryIDQuickAdd, setParentCategoryIDQuickAdd] = useState(0);
  const [categoryTypeNameQuickAdd, setCategoryTypeNameQuickAdd] = useState("");

  const fnCallbackQuickAddCategory = (categoryID, categoryName) => {
    if (categoryTypeQuickAdd == 8) {
      // 8 = Unit
      setUnitOptions([
        {
          value: categoryID,
          label: categoryName,
        },
        ...unitOptions,
      ]);
    }
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Material Categories</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>
                  {"  "}
                  Reset
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                    //setShowFilter(false);
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i> Reload
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 17 && x?.IsExport)
                  ?.length > 0 ? (
                  <Link
                    // className="btn btn-primary light btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                ) : (
                  ""
                )}
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 17 && x?.IsAdd)?.length >
                  0 ? (
                  <Link
                    to="#"
                    // className="btn btn-primary btn-sm"
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => add_category()}
                  >
                    <i className="fa-solid fa-plus"></i> Add {categoryTypeName}
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <Row className="ps-1 me-0">
                <Col lg={2} className="p-1">
                  <div className="basic-list-group">
                    <ListGroup as="ul" style={{ borderRadius: "0" }}>
                      {categoryTypeList?.map((list, i) => (
                        <Fragment key={i}>
                          <ListGroup.Item
                            as="li"
                            style={{
                              cursor: "pointer",
                              padding: "0.67rem 1rem",
                            }}
                            className={
                              list.CategoryType === categoryType ? "active" : ""
                            }
                            onClick={() => {
                              setCategoryTypeName(list.Name);
                              setCategoryType(list.CategoryType);
                              formik.setFieldValue(
                                "CategoryType",
                                list.CategoryType,
                              );
                              formikFilter.setValues({
                                Status: -1,
                                Search: "",
                              });
                            }}
                          >
                            {list.Name}
                          </ListGroup.Item>
                        </Fragment>
                      ))}
                    </ListGroup>
                  </div>
                </Col>
                <Col lg={10} className="p-1">
                  {showFilter ? (
                    <div>
                      <FormikProvider value={formikFilter}>
                        <Form onSubmit={formikFilter.handleSubmit}>
                          <Row className="me-0">
                            <Col lg={3}>
                              <Field
                                label="Search"
                                name="Search"
                                placeholder={"Search here..."}
                                component={CustomInput}
                              />
                            </Col>
                            <Col lg={3}>
                              <Field
                                label="Status"
                                name="Status"
                                placeholder={"Select Status"}
                                options={statusOptions}
                                component={CustomSelect}
                                isClearable={false}
                              />
                            </Col>
                            <Col lg={3}>
                              <label className="mb-1">&nbsp;</label>
                              <div className="d-flex">
                                <div className="d-lg-block">
                                  <Link
                                    // className="btn btn-primary btn-sm mb-1"
                                    className="btn btn-primary btn-sm"
                                    onClick={(e) => {
                                      getData();
                                    }}
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    Search
                                  </Link>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      </FormikProvider>
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    id="MaterialCategories-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="MaterialCategories-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="6%"></th>
                          <th
                            style={{
                              width: "30%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("CategoryName");
                            }}
                          >
                            {categoryTypeName}{" "}
                            <span className="ml-1">
                              {sortBy == "CategoryName" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          {categoryType == 2 && (
                            <>
                              <th
                                style={{
                                  width: "10%",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleClickSorting("UnitName");
                                }}
                              >
                                Unit Name{" "}
                                <span className="ml-1">
                                  {sortBy == "UnitName" ? (
                                    orderBy == "desc" ? (
                                      <i
                                        className="fa fa-arrow-down ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    ) : (
                                      <i
                                        className="fa fa-arrow-up ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    )
                                  ) : (
                                    <i
                                      className="fa fa-sort ms-2 fs-14"
                                      style={{ opacity: "0.3" }}
                                    />
                                  )}
                                </span>
                              </th>
                              <th
                                style={{
                                  width: "10%",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleClickSorting("ShortCode");
                                }}
                              >
                                Short Code{" "}
                                <span className="ml-1">
                                  {sortBy == "ShortCode" ? (
                                    orderBy == "desc" ? (
                                      <i
                                        className="fa fa-arrow-down ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    ) : (
                                      <i
                                        className="fa fa-arrow-up ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    )
                                  ) : (
                                    <i
                                      className="fa fa-sort ms-2 fs-14"
                                      style={{ opacity: "0.3" }}
                                    />
                                  )}
                                </span>
                              </th>
                              <th
                                style={{
                                  width: "10%",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleClickSorting("ReadingCount");
                                }}
                              >
                                Reading Count{" "}
                                <span className="ml-1">
                                  {sortBy == "ReadingCount" ? (
                                    orderBy == "desc" ? (
                                      <i
                                        className="fa fa-arrow-down ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    ) : (
                                      <i
                                        className="fa fa-arrow-up ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    )
                                  ) : (
                                    <i
                                      className="fa fa-sort ms-2 fs-14"
                                      style={{ opacity: "0.3" }}
                                    />
                                  )}
                                </span>
                              </th>
                            </>
                          )}
                          {categoryType == 1 &&
                            AuthUser?.Permissions?.FoodTesting == 1 && (
                              <th
                                style={{
                                  width: "10%",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleClickSorting("DisposalDays");
                                }}
                              >
                                Disposal Days{" "}
                                <span className="ml-1">
                                  {sortBy == "DisposalDays" ? (
                                    orderBy == "desc" ? (
                                      <i
                                        className="fa fa-arrow-down ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    ) : (
                                      <i
                                        className="fa fa-arrow-up ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    )
                                  ) : (
                                    <i
                                      className="fa fa-sort ms-2 fs-14"
                                      style={{ opacity: "0.3" }}
                                    />
                                  )}
                                </span>
                              </th>
                            )}
                          <th
                            style={{
                              width: "39%",
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                            onClick={() => {
                              handleClickSorting("Description");
                            }}
                          >
                            Description{" "}
                            <span className="ml-1">
                              {sortBy == "Description" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {categoryList?.length > 0 ? (
                          categoryList?.map((item, indx) => (
                            <tr key={indx}>
                              <td>
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 17 && x?.IsEdit,
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                    onClick={() =>
                                      get_MaterialCategoryByID(
                                        item.MaterialCategoryIDEncrypted,
                                      )
                                    }
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 17 && x?.IsActive,
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className={`icon-box icon-box-md bg-${
                                    //   item.IsActive == true ? "success" : "danger"
                                    // }-light me-1`}
                                    className={`icon-box icon-box-md me-1`}
                                    title={
                                      item.IsActive == true
                                        ? "Active"
                                        : "Inactive"
                                    }
                                    onClick={() => {
                                      ActiveInactive_Record(
                                        item.IsActive,
                                        POST_MaterialCategoryStatusUpdate,
                                        {
                                          MaterialCategoryIDEncrypted:
                                            item.MaterialCategoryIDEncrypted,
                                          IsActive: !item.IsActive,
                                          ModifiedByEncrypted:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.CategoryName,
                                      );
                                    }}
                                  >
                                    <i
                                      className={`fa fa-circle fs-15 ${
                                        item.IsActive == true
                                          ? "text-success"
                                          : "text-danger"
                                      }`}
                                    ></i>
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 17 && x?.IsDelete,
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      delete_Record(
                                        POST_MaterialCategoryDelete,
                                        {
                                          MaterialCategoryIDEncrypted:
                                            item.MaterialCategoryIDEncrypted,
                                          ModifiedByEncrypted:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.CategoryName,
                                      );
                                    }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>{item.CategoryName}</td>
                              {categoryType == 2 && <td>{item.Unit}</td>}
                              {categoryType == 2 && <td>{item.ShortCode}</td>}
                              {categoryType == 2 && (
                                <td>
                                  {item.ReadingCount == 0
                                    ? ""
                                    : item.ReadingCount}
                                </td>
                              )}
                              {categoryType == 1 &&
                                AuthUser?.Permissions?.FoodTesting == 1 && (
                                  <td>{item.DisposalDays}</td>
                                )}
                              {/* <td style={{ textAlign: "left" }}>
                                {item.Description}
                              </td> */}
                              <td
                                style={{ textAlign: "left", cursor: "pointer" }}
                                className="popupOverlay"
                              >
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={indx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip
                                      className="toltip-popover"
                                      // id={`popover-positioned-${item.Description.toLowerCase()}`}
                                    >
                                      <strong className="p-1">
                                        {item.Description}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>{item.Description}</span>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={7} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <CustomSizePerPage
                        getData={getData}
                        currentSizePerPage={currentSizePerPage}
                      />
                      <div className="dataTables_info">
                        Showing{" "}
                        {recordCount > 0
                          ? (currentPage - 1) * currentSizePerPage + 1
                          : 0}{" "}
                        to{" "}
                        {recordCount > currentPage * currentSizePerPage
                          ? currentPage * currentSizePerPage
                          : recordCount}{" "}
                        of {recordCount} entries
                      </div>
                      <CustomPaginationButtons
                        totalPages={recordCount / currentSizePerPage}
                        currentPage={currentPage}
                        currentSizePerPage={currentSizePerPage}
                        getData={getData}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Spin>
        <Modal
          size={categoryType == 2 ? "xl" : ""}
          className="fade"
          show={categoryModal}
          onHide={setCategoryModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>{categoryTypeName}</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setCategoryModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={categoryType == 2 ? 6 : 12}>
                      <Row>
                        <Col lg={12}>
                          <Field
                            type="text"
                            label={categoryTypeName}
                            name="CategoryName"
                            placeholder={`Enter ${categoryTypeName}`}
                            component={CustomInput}
                            maxLength={250}
                            required
                            autoFocus
                            onChange={(e) => {
                              formik.setFieldValue(
                                "CategoryName",
                                capitalizeString(e?.target?.value),
                              );
                            }}
                          />
                        </Col>
                        {categoryType == 2 && (
                          <>
                            <Col lg={12}>
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 17 && x?.IsAdd,
                              )?.length > 0 ? (
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md bg-primary-light me-1"
                                  title="New Unit"
                                  style={{ float: "right" }}
                                  onClick={() => {
                                    setCategoryTypeQuickAdd(8); // 8 = Unit
                                    setCategoryTypeNameQuickAdd("Unit");
                                    setParentCategoryIDQuickAdd(0);
                                    setShowQuickAddCategoryModal(true);
                                  }}
                                >
                                  <i className="fa fa-plus"></i>
                                </Link>
                              ) : (
                                ""
                              )}
                              <Field
                                label="Unit"
                                name="UnitID"
                                placeholder={"Select Unit"}
                                component={CustomSelect}
                                options={unitOptions}
                              />
                            </Col>
                            <Col lg={12}>
                              <label className="mb-1">
                                Short Code &nbsp;
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {" "}
                                        Short code to be used in formula. It
                                        should be unique. Constant like 'Pi',
                                        'E' & 'NULL' can not be used as short
                                        code.
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <i
                                      className="fa fa-info-circle"
                                      style={{
                                        cursor: "pointer",
                                        color: "#9698ab",
                                      }}
                                    ></i>
                                  </span>
                                </OverlayTrigger>
                              </label>
                              <Field
                                name="ShortCode"
                                placeholder={"Enter Short Code"}
                                component={CustomInput}
                                maxLength={50}
                                onChange={(e) => {
                                  const inputValue = e?.target?.value ?? "";
                                  formik.setFieldValue(
                                    "ShortCode",
                                    inputValue.replace(/\s+/g, ""),
                                  ); //doesn't allow space
                                }}
                              />
                            </Col>
                          </>
                        )}
                        {categoryType == 1 &&
                          AuthUser?.Permissions?.FoodTesting == 1 && (
                            <>
                              <Col lg={12}>
                                <Field
                                  type="number"
                                  label={"Disposal Days"}
                                  name="DisposalDays"
                                  placeholder={"Enter Disposal Days"}
                                  component={CustomInput}
                                  numberTypeWithoutDot={true}
                                />
                              </Col>
                            </>
                          )}
                        {categoryType == 2 ? (
                          <Col lg={12}>
                            <Field
                              label="Reading Count"
                              type="number"
                              name="ReadingCount"
                              placeholder={"Enter Reading Count"}
                              component={CustomInput}
                              numberTypeWithoutDot={true}
                              onChange={(e) => {
                                const inputValue = e?.target?.value ?? "";
                                formik.setFieldValue(
                                  "ReadingCount",
                                  inputValue ?? "",
                                );
                              }}
                            />
                          </Col>
                        ) : (
                          ""
                        )}

                        <Col lg={12}>
                          <Field
                            type="text"
                            label="Description"
                            name="Description"
                            placeholder={"Enter Description"}
                            component={CustomTextArea}
                            maxLength={500}
                            rows={5}
                          />
                        </Col>
                      </Row>
                    </Col>
                    {categoryType == 2 && (
                      <Col lg={6}>
                        <Row>
                          <Col lg={12} className="mb-2">
                            <label className="mb-1">Machines Mapping</label>
                            <div className="card mb-0 w-100">
                              <div className="card-header p-0">
                                <input
                                  type="text"
                                  name="searchParameterMachines"
                                  placeholder={"Search here..."}
                                  className="form-control form-control-sm"
                                  value={searchParameterMachines}
                                  onChange={handleChangeSearchParameterMachines}
                                  style={{
                                    borderBottomLeftRadius: "0",
                                    borderBottomRightRadius: "0",
                                  }}
                                ></input>
                              </div>
                              <div
                                className="card-body p-0 table-responsive"
                                style={{ maxHeight: "200px", overflow: "auto" }}
                              >
                                <table className="table table-hover header-border no-footer">
                                  <tbody>
                                    {ParameterMachineLinkList?.filter(
                                      (x) => x.display == true,
                                    )?.length > 0 ? (
                                      ParameterMachineLinkList?.map(
                                        (item, idx) => (
                                          <tr
                                            key={idx}
                                            style={{
                                              display:
                                                item.display == true
                                                  ? ""
                                                  : "none",
                                            }}
                                          >
                                            <td
                                              style={{
                                                textAlign: "center",
                                                padding: "0.5rem",
                                                width: "12%",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`chkParameterMachine${idx}`}
                                                name={`chkParameterMachine${idx}`}
                                                checked={item.IsSelected}
                                                onChange={(e) => {
                                                  formik.setFieldValue(
                                                    `ParameterMachineLinkList[${idx}].IsSelected`,
                                                    e.target.checked,
                                                  );
                                                  // unticking a machine also clears its CSV parameter selections
                                                  if (!e.target.checked) {
                                                    formik.setFieldValue(
                                                      "ParameterMachineMappingList",
                                                      ParameterMachineMappingList?.map(
                                                        (x) =>
                                                          x.MachineIDEncrypt ==
                                                          item.MachineIDEncrypt
                                                            ? {
                                                                ...x,
                                                                IsSelected: false,
                                                              }
                                                            : x,
                                                      ),
                                                    );
                                                  }
                                                }}
                                              />
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "left",
                                                padding: "0.5rem",
                                                width: "88%",
                                              }}
                                            >
                                              {item.MachineName}
                                            </td>
                                          </tr>
                                        ),
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          colSpan={2}
                                          style={{ textAlign: "center" }}
                                        >
                                          <div>{"No options"}</div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                          <Col lg={12} className="mb-2">
                            <label className="mb-1">
                              Machine CSV Parameters Mapping
                            </label>
                            <div className="card mb-0 w-100">
                              <div className="card-header p-0">
                                <input
                                  type="text"
                                  name="searchMachineParameters"
                                  placeholder={"Search here..."}
                                  className="form-control form-control-sm"
                                  value={searchMachineParameters}
                                  onChange={handleChangeSearchMachineParameters}
                                  style={{
                                    borderBottomLeftRadius: "0",
                                    borderBottomRightRadius: "0",
                                  }}
                                ></input>
                              </div>
                              <div
                                className="card-body p-0 table-responsive"
                                style={{ maxHeight: "250px", overflow: "auto" }}
                              >
                                <table className="table table-hover header-border no-footer">
                                  <tbody>
                                    {ParameterMachineMappingList?.filter((x) =>
                                      isCsvRowVisible(x),
                                    )?.length > 0 ? (
                                      ParameterMachineMappingList?.map(
                                        (item, idx) => (
                                          <tr
                                            key={idx}
                                            style={{
                                              display: isCsvRowVisible(item)
                                                ? ""
                                                : "none",
                                            }}
                                          >
                                            <td
                                              style={{
                                                textAlign: "center",
                                                padding: "0.5rem",
                                                width: "12%",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`chkMachineParameter${idx}`}
                                                name={`chkMachineParameter${idx}`}
                                                checked={item.IsSelected}
                                                onChange={(e) => {
                                                  formik.setFieldValue(
                                                    `ParameterMachineMappingList[${idx}].IsSelected`,
                                                    e.target.checked,
                                                  );
                                                }}
                                              />
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "left",
                                                padding: "0.5rem",
                                                width: "88%",
                                              }}
                                            >
                                              <span>{item.MachineParameter}</span>
                                              <span
                                                style={{
                                                  fontSize: "9px",
                                                  display: "block",
                                                }}
                                              >
                                                {item.MachineName}
                                              </span>
                                            </td>
                                          </tr>
                                        ),
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          colSpan={2}
                                          style={{ textAlign: "center" }}
                                        >
                                          <div>
                                            {ParameterMachineLinkList?.some(
                                              (m) => m.IsSelected,
                                            )
                                              ? "No options"
                                              : "Select machines in Machines Mapping first"}
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Row>
                  {showQuickAddCategoryModal == true && (
                    <div className="fade modal-backdrop show"></div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setCategoryModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <QuickAddCategory
          categoryType={categoryTypeQuickAdd}
          parentCategoryID={parentCategoryIDQuickAdd}
          showModal={showQuickAddCategoryModal}
          setShowModal={setShowQuickAddCategoryModal}
          categoryTypeName={categoryTypeNameQuickAdd}
          fnCallback={fnCallbackQuickAddCategory}
        />
      </div>
    </div>
  );
};

export default MaterialCategories;
